import httpUtil from "@/utils/httpUtil";

export function addSmsTemplate(params, type) {
  return httpUtil.post("/api/crmPc/sms/addTemplate", params, type);
}

export function updateSmsTemplate(params, type) {
  return httpUtil.post("/api/crmPc/sms/updateTemplate", params, type);
}

export function deleteSmsTemplate(params, type) {
  return httpUtil.post("/api/crmPc/sms/deleteTemplate", params, type);
}

export function querySmsTemplatePage(params, type) {
  return httpUtil.post("/api/crmPc/sms/queryTemplatePage", params, type);
}

export function queryEnabledSmsTemplates(params, type) {
  return httpUtil.post("/api/crmPc/sms/queryEnabledTemplates", params, type);
}

export function createSmsSendTask(params, type) {
  return httpUtil.post("/api/crmPc/sms/createSendTask", params, type);
}

export function querySmsTaskPage(params, type) {
  return httpUtil.post("/api/crmPc/sms/queryTaskPage", params, type);
}

export function querySmsRecordPage(params, type) {
  return httpUtil.post("/api/crmPc/sms/queryRecordPage", params, type);
}
